import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { TcDirectoryEligibilityProps } from '../_types';
import { classnames } from 'tailwindcss-classnames';
import PediatricEligibility from './_PediatricEligibility';

const PatientEligibilityComponent = ({ fields }: TcDirectoryEligibilityProps) => {
  if (!fields) {
    return <MissingDataSource />;
  }
  const ageGroup = fields?.ageGroup?.fields as { Value: { value: string } };
  const renderAdultEligibility = () => {
    const acceptsAdultsAfterPedTxMessage = fields?.adultAfterPed
      ? 'Will provide care to adult patients who underwent transplant as a child'
      : 'Does not provide care to adult patients who underwent transplant as a child';

    const transferAcceptanceMessage = fields?.anyTx?.value
      ? 'Does accept patients who were transplanted at another hospital'
      : 'Does not accept patients who were transplanted at another hospital';

    return (
      <>
        <b>Adults</b>
        <ul className={classnames('p-4', 'space-y-2')}>
          {fields?.TransplantTypes?.value && (
            <li className={classnames('list-disc')}>
              {fields.TransplantTypes.value.replace(/\r\n/g, ' and ')} transplant recipients
            </li>
          )}
          {fields?.minTimePostTx?.value && (
            <li className={classnames('list-disc')}>
              Adults: {fields.minTimePostTx.value} after transplant.
            </li>
          )}
          <li className={classnames('list-disc')}>
            Adults (over age {fields?.ageBoundary?.value})
            <ul className={classnames('pt-2')}>
              <li className={classnames('list-disc', 'list-inside')}>
                {acceptsAdultsAfterPedTxMessage}
              </li>
            </ul>
          </li>
          <li className={classnames('list-disc')}>{transferAcceptanceMessage}</li>
        </ul>
      </>
    );
  };

  return (
    <div>
      {ageGroup?.Value?.value === 'Adult' ? (
        renderAdultEligibility()
      ) : (
        <PediatricEligibility fields={fields} />
      )}
    </div>
  );
};
export default PatientEligibilityComponent;
